<div class="modal is-active" >
  <div class="modal-background" />

  <div class="modal-card" class:is-wide={isWide}>
    <header class="modal-card-head">
      <p class="modal-card-title">{title}</p>
      <button
        class="delete"
        aria-label="close"
        on:click={() => dispatch('close')} />
    </header>
    <section class="modal-card-body">
      <slot />
    </section>
    <footer class="modal-card-foot">
      {#if isInfo}
      <button class="button" on:click={() => dispatch('close')}>OK</button>
      {:else}
      <button class="button" class:is-success={!isDanger} class:is-danger={isDanger} class:is-loading={isLoading} on:click={() => dispatch('action')}>
        {actionTitle}
      </button>
      <button class="button" on:click={() => dispatch('close')}>Cancel</button>
      {/if}
    </footer>
  </div>
</div>

<script lang="ts">
  export let title :string, actionTitle = "OK", isLoading = false, isDanger = false, isInfo = false, isWide = false;
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
</script>

<style>
  @media (min-width:1024px) {
    .is-wide {
      width:900px;
    }
  }
</style>